import { render, staticRenderFns } from "./BotaoFavoritos.vue?vue&type=template&id=2c52f6f7&scoped=true&"
import script from "./BotaoFavoritos.vue?vue&type=script&lang=js&"
export * from "./BotaoFavoritos.vue?vue&type=script&lang=js&"
import style0 from "./BotaoFavoritos.vue?vue&type=style&index=0&id=2c52f6f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52f6f7",
  null
  
)

export default component.exports